import Text from '../../components/kit/text/Text';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
  return (
    <div className={styles.wrapper}>
      <Text weight='bold' size='x-large' tag='h1' centered>
        404 - Page Not Found
      </Text>
      <Text>The page you're looking for does not exist</Text>
    </div>
  );
};

export default NotFoundPage;
